let currentStep=1,currentQuizProduct;const quizProduct={handle:void 0,product_id:void 0,variant_id:void 0},quizSelection={grind:void 0,type:void 0,volume:void 0,product:void 0,strength:void 0,flavour:void 0},resetProduct=()=>{quizProduct.handle=void 0,quizProduct.product_id=void 0,quizProduct.variant_id=void 0};
function getSelectedVariant(e){if(1===e.variants.length){const t=e.variants[0];return quizProduct.handle=e.handle,quizProduct.product_id=e.id,quizProduct.variant_id=t.id,"Default Title"===t.title?"":t.title}let t="";for(const r of e.variants){var o;let e="";if(e="bean"==quizSelection.grind?"Whole Bean":quizSelection.type,o=quizSelection.volume,r.title.match(e)&&r.title.match(o)){t=r.title,quizProduct.variant_id=r.id;break}}return quizProduct.handle=e.handle,quizProduct.product_id=e.id,console.log(quizProduct),t}
function initProductQuantity(){var e=document.querySelectorAll(".product-quantity");if(e)for(const t of e)if(!t.classList.contains("initialized")){const r=t.querySelectorAll(".increment");for(let o=0;o<r.length;o++)r[o].addEventListener("click",function(){var e=r[o].parentNode.querySelector("input");let t=e.value;if(r[o].classList.contains("down")){if(t<=1)return;t--}return r[o].classList.contains("up")&&t++,e.value=t});t.classList.add("initialized")}}
function removeSubscriptionOptions(){document.querySelector(".quiz-subscription").innerHTML=""}
function renderSubscriptionOptions(e){var t=document.querySelector(".recharge-options"),o=document.querySelector(".quiz-subscription"),r=(o.innerHTML="",document.createElement("select")),e=(r.setAttribute("id","sellingPlan"+e.id),r.setAttribute("name","selling_plan"),r.setAttribute("aria-label","Delivery frequency"),e.selling_plan_groups);if(0==e.length)t.style.display="none",removeSubscriptionOptions();else{t.style.display="flex";for(const n of e){var i=document.createElement("option");i.setAttribute("value",n.selling_plans[0].id),i.textContent=n.name,r.appendChild(i)}o.appendChild(r)}document.querySelector(".quiz-step--7").classList.remove("hidden"),document.querySelector(".quiz-step--7").scrollIntoView({behaviour:"smooth",block:"center"})}
function initProductCard(){const o=document.querySelector(".recharge-options").querySelectorAll("label");o[0].classList.add("active"),o[0].querySelector("input").checked=!0,window.initAddToCart();for(const r of o){const e=r.querySelector('input[type="radio"]');r.classList.contains("initialized")||(e.addEventListener("change",()=>{if(e.checked){for(const e of o)e.classList.remove("active");r.classList.add("active"),"single"==e.value&&removeSubscriptionOptions(),"sub"==e.value&&currentQuizProduct&&renderSubscriptionOptions(currentQuizProduct)}}),r.classList.add("initialized"))}}
function renderSelectedProduct(e){console.log("Product:",e),currentQuizProduct=e;var t=document.querySelector(".quiz-product__image"),o=document.querySelector(".quiz-product__title"),r=document.querySelector(".quiz-product__variant"),i=document.querySelector(".quiz-form"),n=document.querySelector(".quiz-variant"),c=document.querySelector(".product-id"),l=(t.innerHTML="",o.innerHTML="",r.innerHTML="",document.createElement("img")),t=(l.setAttribute("src",e.image),l.setAttribute("alt",e.title),t.appendChild(l),document.createElement("span")),l=(t.textContent=e.title,o.appendChild(t),getSelectedVariant(e)),o=document.createElement("span");o.textContent=l,r.append(o),i.setAttribute("id","product_form_"+e.id),n.value=quizProduct.variant_id,c.value=quizProduct.product_id,renderSubscriptionOptions(e)}
function getRelatedProduct(){null!=quizSelection.product&&fetch(window.Shopify.routes.root+"products/"+quizSelection.product+"?view=json").then(e=>e.json()).then(e=>{renderSelectedProduct(e),initProductCard(),initProductQuantity()})}
function getGrind(){return quizSelection.grind}
function setProgressBar(e){var t=document.querySelector(".step-indicator").querySelectorAll("li");for(const e of t)e.classList.remove("active");var o=e-1;for(let e=0;e<o;e++)t[e].classList.add("active")}
function updateQuizControlAvailability(){for(const e of document.querySelectorAll(".quiz-step")){const t=Number(e.dataset.step)<=currentStep;for(const o of e.querySelectorAll('input[type="radio"]')){const e=o.closest("li, .swiper-slide"),r=e&&"none"===e.style.display;o.disabled=!t||r}}}
function SetStepStatus(){for(const t of document.querySelectorAll(".quiz-step")){var e=Number(t.dataset.step);if(e<=currentStep?t.classList.remove("disabled"):t.classList.add("disabled"),e>=currentStep){e=t.querySelectorAll("label");if(e)for(const o of e){const t=o.querySelector('input[type="radio"]');o.classList.remove("active"),t&&(t.checked=!1)}}}updateQuizControlAvailability(),window.initStep(currentStep),setProgressBar(currentStep)}

// Corrected filterFlavours function (Filters by BOTH Type and Strength)
function filterFlavours(){
    var selectedGrind = quizSelection.grind || null;
    var selectedStrength = quizSelection.strength || null;
    var flavourListItems = document.querySelectorAll('.fieldset-step-5 li');

    var requiredType = selectedGrind === 'pod' ? 'coffee-pods' : 'freshly-roasted-coffee';

    // If neither strength nor grind is selected, we do nothing and show all flavors (initial load)
    if (!selectedGrind && !selectedStrength) {
        flavourListItems.forEach(function(li) { li.style.display = ''; });
        return;
    }

    flavourListItems.forEach(function(li) {
        var productType = li.getAttribute('data-product-type');
        var strength = li.getAttribute('data-strength'); 
        var input = li.querySelector('input');
        
        var isVisible = true;

        // 1. Filter by Product Type (Pod vs. Coffee)
        if (selectedGrind && productType !== requiredType) {
            isVisible = false;
        }
        
        // 2. Filter by Strength (Decaf vs. Regular)
        // If Decaf is selected OR Regular is selected, apply the filter strictly.
        if (isVisible && selectedStrength) {
            if (strength !== selectedStrength) {
                isVisible = false;
            }
        }
        
        li.style.display = isVisible ? '' : 'none';
        if (input) input.disabled = !isVisible;

        if (!isVisible && input && input.checked) {
            input.checked = false;
        }
    });
}

// Corrected filterProducts function (handles all filtering logic strictly)
function filterProducts(){
    var selectedStrength = quizSelection.strength || null;
    var selectedGrind = quizSelection.grind || null;
    var selectedFlavour = quizSelection.flavour || null;
    var allProducts = document.querySelectorAll(".swiper-quiz .swiper-slide");
    
    var isAnyFilterActive = selectedGrind || selectedStrength || selectedFlavour;

    allProducts.forEach(function(slide) {
        var productType = slide.getAttribute('data-product-type');
        var strength = slide.getAttribute('data-strength');
        var productFlavours = slide.getAttribute('data-flavours');

        var isVisible = true;

        // CRITICAL 1: Initial State Logic: If NO filters are active, show everything.
        if (!isAnyFilterActive) {
            isVisible = true; 
        } else {
            // === Filtering Logic (Strict AND logic) ===
            
            // Filter 1: STRENGTH (Must match if selected)
            if (selectedStrength) {
                if (strength !== selectedStrength) {
                    isVisible = false;
                }
            }
            
            // Filter 2: GRIND / PRODUCT TYPE (Must match if selected)
            if (isVisible && selectedGrind) {
                if (selectedGrind === 'pod' && productType !== 'coffee-pods') {
                    isVisible = false;
                } else if (selectedGrind !== 'pod' && productType === 'coffee-pods') {
                    isVisible = false;
                }
            }
            
            // Filter 3: FLAVOUR (Must contain selected flavour if selected)
            if (isVisible && selectedFlavour) {
                // Ensure productFlavours is valid before checking includes
                if (!productFlavours || !productFlavours.includes(selectedFlavour)) {
                     isVisible = false;
                }
            }
        }
        
        slide.style.display = isVisible ? '' : 'none';
        const input = slide.querySelector('input[type="radio"]');
        if (input) input.disabled = !isVisible;
    });

    // Recalculate the swiper.
    if (typeof quizSwiperInstance !== 'undefined' && quizSwiperInstance) {
        setTimeout(function() {
            quizSwiperInstance.update();
        }, 0); 
    }
    
    // Rerun flavour filtering logic (to hide options if Pod or Decaf is selected)
    filterFlavours();
}

function getSelectionFromOptions(){var e;for(const t of document.querySelector(".quiz-steps").querySelectorAll("fieldset"))for(const o of t.querySelectorAll('input[type="radio"]'))1==o.checked&&(e=o.getAttribute("name"),quizSelection[e]=o.value);SetStepStatus()}
function toggleLabelStates(e){
    if("bean"==e||"ground"==e||"pod"==e){
        selectedOption="bean"===e||"ground"===e?"ground":"pod";
        for(const t of document.querySelectorAll("label")){
            if(t.dataset.type){
                t.dataset.type!==selectedOption?t.parentNode.style.display="none":t.parentNode.style.display="block"
            }
        }
    }
}
// Function exposed globally for Liquid to call
window.initStep=function(t){
    updateQuizControlAvailability();
    if(7==currentStep)getRelatedProduct();
    else{
        var e=document.querySelector(".fieldset-step-"+t);
        if(e){
            const o=e.querySelectorAll("label");
            if(o){
                for(const r of o){
                    const input = r.querySelector('input[type="radio"]');
                    r.classList.contains("initialized")||(input.addEventListener("change",()=>{
                        if(input.checked&&!r.classList.contains("active")){
                            filterProducts(); 
                            for(const r of o)r.classList.remove("active");
                            r.classList.add("active"),currentStep=t+1,getSelectionFromOptions(),toggleLabelStates(input.value),filterProducts(),updateQuizControlAvailability()
                        }
                    }),r.classList.add("initialized"))
                }
            }
        }
    }
};
